<!-- ImportEmployeesModal.vue -->
<template>
  <modal :show.sync="showModal" @close="closeModal">
    <template slot="header">
      <h4 class="modal-title">Importar Funcionários</h4>
    </template>

    <div class="container">
      <div class="row">
        <div class="col-12">
          <div
            class="upload-area"
            :class="{ dragover: isDragging }"
            @dragover.prevent="isDragging = true"
            @dragleave.prevent="isDragging = false"
            @drop.prevent="handleDrop"
          >
            <input
              type="file"
              ref="fileInput"
              accept=".xlsx, .xls"
              @change="handleFileSelect"
              style="display: none"
            />
            <div class="upload-text" @click="$refs.fileInput.click()">
              <i class="tim-icons icon-upload"></i>
              <p>
                {{
                  file
                    ? file.name
                    : "Clique aqui ou arraste um arquivo Excel (.xlsx, .xls)"
                }}
              </p>
            </div>
          </div>

          <div v-if="file" class="file-info mt-3">
            <p>Arquivo selecionado: {{ file.name }}</p>
            <base-button type="danger" size="sm" @click="clearFile">
              Remover
            </base-button>
          </div>
        </div>
      </div>

      <div v-if="error" class="alert alert-danger mt-3">
        {{ error }}
      </div>
    </div>

    <template slot="footer">
      <base-button type="danger" :disabled="isLoading" @click="closeModal">
        Cancelar
      </base-button>
      <base-button
        type="success"
        :disabled="isLoading || !file"
        @click="uploadFile"
      >
        <span v-if="isLoading">
          <i class="fa fa-spinner fa-spin"></i> Carregando...
        </span>
        <span v-else>Importar</span>
      </base-button>
    </template>
  </modal>
</template>

<script>
import Modal from "@/components/Modal.vue";
import { BaseButton } from "@/components";

export default {
  name: "ImportEmployeesModal",
  components: {
    Modal,
    BaseButton,
  },
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      showModal: false,
      file: null,
      isDragging: false,
      isLoading: false,
      error: null,
    };
  },
  watch: {
    visible(newVal) {
      this.showModal = newVal;
    },
  },
  methods: {
    handleFileSelect(event) {
      const files = event.target.files;
      if (files && files.length > 0) {
        this.validateAndSetFile(files[0]);
      }
    },
    handleDrop(event) {
      this.isDragging = false;
      const files = event.dataTransfer.files;
      if (files && files.length > 0) {
        this.validateAndSetFile(files[0]);
      }
    },
    validateAndSetFile(file) {
      const validTypes = [
        "application/vnd.ms-excel",
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      ];

      if (!validTypes.includes(file.type)) {
        this.error =
          "Por favor, selecione um arquivo Excel válido (.xls ou .xlsx)";
        this.file = null;
        return;
      }

      this.file = file;
      this.error = null;
    },
    clearFile() {
      this.file = null;
      this.$refs.fileInput.value = "";
      this.error = null;
    },
    async uploadFile() {
      if (!this.file) return;

      this.isLoading = true;
      const formData = new FormData();
      formData.append("file", this.file);
      formData.append("setDB", this.$cookies.get("db"));
      formData.append("id_empregador", this.$cookies.get("idEmpregador"));

      try {
        const response = await this.axios.post(
          "/api/empregado/importarFuncionarios",
          formData,
          {
            headers: {
              "Content-Type": "multipart/form-data",
              "id-actor": this.$cookies.get("id_actor"),
              "tipo-actor": this.$cookies.get("tipo_actor"),
            },
          },
        );

        this.$emit("success", response.data);
        this.closeModal();
        this.showSuccessNotification();
      } catch (error) {
        this.error = error || "Erro ao importar funcionários";
      } finally {
        this.isLoading = false;
      }
    },
    closeModal() {
      this.clearFile();
      this.error = null;
      this.$emit("update:visible", false);
    },
    showSuccessNotification() {
      this.$notify({
        type: "success",
        message: "Funcionários importados com sucesso!",
        horizontalAlign: "right",
        verticalAlign: "top",
      });
    },
  },
};
</script>

<style scoped>
.upload-area {
  border: 2px dashed #ccc;
  border-radius: 5px;
  padding: 20px;
  text-align: center;
  cursor: pointer;
  transition: all 0.3s ease;
}

.upload-area.dragover {
  background-color: #e1f4f0;
  border-color: #35a887;
}

.upload-text {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
}

.upload-text i {
  font-size: 2rem;
  color: #35a887;
}

.upload-text p {
  margin: 0;
  color: #666;
}

.file-info {
  display: flex;
  align-items: center;
  gap: 10px;
}
</style>
